var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3780_747",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 29,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4928 17.9999C31.4928 25.0131 25.4522 30.6983 18.0007 30.6983C15.9133 30.6983 13.9366 30.2522 12.1724 29.4557L12.249 29.5247L3.71484 31.4919L6.3496 24.4072C5.17941 22.5264 4.50866 20.3369 4.50866 17.9999C4.50866 10.9868 10.5493 5.30151 18.0007 5.30151C25.4522 5.30151 31.4928 10.9868 31.4928 17.9999ZM11.6515 20.3807C12.5282 20.3807 13.2388 19.67 13.2388 18.7934C13.2388 17.9168 12.5282 17.2061 11.6515 17.2061C10.7749 17.2061 10.0642 17.9168 10.0642 18.7934C10.0642 19.67 10.7749 20.3807 11.6515 20.3807ZM19.5881 18.7934C19.5881 19.67 18.8775 20.3807 18.0008 20.3807C17.1242 20.3807 16.4135 19.67 16.4135 18.7934C16.4135 17.9168 17.1242 17.2061 18.0008 17.2061C18.8775 17.2061 19.5881 17.9168 19.5881 18.7934ZM23.5563 20.3807C24.433 20.3807 25.1436 19.67 25.1436 18.7934C25.1436 17.9168 24.433 17.2061 23.5563 17.2061C22.6797 17.2061 21.969 17.9168 21.969 18.7934C21.969 19.67 22.6797 20.3807 23.5563 20.3807Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3780_747)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.142578,
    y: 0.539307,
    width: 35.0518,
    height: 35.0518,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMessageIcon);
export default __webpack_public_path__ + "static/media/profile-message-icon.f49b10dc859d009db0b824b997fceb81.svg";
export { ForwardRef as ReactComponent };